"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _RequestProgress_1 = require("./_RequestProgress");
var _InputSerialization_1 = require("./_InputSerialization");
var _OutputSerialization_1 = require("./_OutputSerialization");
exports.SelectObjectContentInput = {
    type: "structure",
    required: [
        "Bucket",
        "Key",
        "Expression",
        "ExpressionType",
        "InputSerialization",
        "OutputSerialization"
    ],
    members: {
        Bucket: {
            shape: {
                type: "string"
            },
            location: "uri",
            locationName: "Bucket"
        },
        Key: {
            shape: {
                type: "string",
                min: 1
            },
            location: "uri",
            locationName: "Key"
        },
        SSECustomerAlgorithm: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "x-amz-server-side-encryption-customer-algorithm"
        },
        SSECustomerKey: {
            shape: {
                type: "string",
                sensitive: true
            },
            location: "header",
            locationName: "x-amz-server-side-encryption-customer-key"
        },
        SSECustomerKeyMD5: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "x-amz-server-side-encryption-customer-key-MD5"
        },
        Expression: {
            shape: {
                type: "string"
            }
        },
        ExpressionType: {
            shape: {
                type: "string"
            }
        },
        RequestProgress: {
            shape: _RequestProgress_1._RequestProgress
        },
        InputSerialization: {
            shape: _InputSerialization_1._InputSerialization
        },
        OutputSerialization: {
            shape: _OutputSerialization_1._OutputSerialization
        }
    }
};
//# sourceMappingURL=SelectObjectContentInput.js.map